import { Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

@Component({
  selector: 'bhub-pdf-line-cell',
  standalone: false,
  templateUrl: './pdf-line-cell.component.html',
  styleUrls: ['./pdf-line-cell.component.scss']
})
export class PdfLineCellComponent extends BaseCellComponent {
  orientation: 'horizontal' | 'vertical' = 'horizontal';
  lineStyle: 'solid' | 'dashed' | 'dotted' = 'solid';
  color = '#000000';
  thickness = 1;

  protected initializeCell(): void {
    this.updateLine();
  }

  protected onCellOrDataChange(): void {
    this.updateLine();
  }

  protected onCellUpdate(): void {
    this.updateLine();
  }

  protected onDataSet(data: any): void {}

  private updateLine(): void {
    this.orientation = this.getConfigValue('pdfLineOrientation', 'horizontal');
    this.lineStyle = this.getConfigValue('pdfLineStyle', 'solid');
    this.color = this.getConfigValue('pdfLineColor', '#000000');
    this.thickness = this.getConfigValue('pdfLineThickness', 1);
  }
}
